import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import useReveal from '../hooks/useReveal';
import Seo from '../components/Seo';
import { PRODUCT_IMAGES, IMAGES } from '../mock/mock';
import { PageHero } from './Services';

const Products = () => {
  const { t, lang } = useLang();
  useReveal(lang);
  const cats = t('products.categories');

  return (
    <div>
      <Seo title="Products We Manufacture — Luxury Skincare, Haircare & Body Care" path="/products"
        description="Premium categories we manufacture for brands: skincare, haircare, body & personal care, baby & sensitive, sun and men's care — formulated with advanced actives under GMP." />
      <PageHero kicker={t('home.productsKicker')} title={t('products.title')} subtitle={t('products.subtitle')} image={IMAGES.bottlesGroup} />
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-24">
          {cats.map((c, i) => (
            <div key={i} className={`grid lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? 'lg:[direction:rtl]' : ''}`}>
              <div className="reveal img-zoom aspect-[4/3] shadow-[0_30px_70px_-30px_rgba(43,36,32,0.35)] [direction:ltr]">
                <img src={PRODUCT_IMAGES[i]} alt={c.title} className="w-full h-full object-cover" />
              </div>
              <div className="reveal [direction:ltr] rtl:text-right">
                <span className="font-serif text-6xl text-gold/25">{String(i + 1).padStart(2, '0')}</span>
                <h2 className="font-serif text-4xl text-espresso -mt-4">{c.title}</h2>
                <p className="mt-5 text-mocha leading-relaxed">{c.desc}</p>
                <div className="mt-7 pt-6 border-t border-gold-soft">
                  <p className="text-[0.68rem] tracking-[0.22em] uppercase text-gold mb-3">{t('products.keyIngredients')}</p>
                  <div className="flex flex-wrap gap-2">
                    {c.ingredients.split(',').map((ing, k) => (
                      <span key={k} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-cream text-xs text-espresso"><Sparkle className="w-3 h-3 text-gold" />{ing.trim()}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="py-20 bg-espresso text-center">
        <div className="max-w-2xl mx-auto px-6 reveal">
          <h2 className="font-serif text-3xl md:text-4xl text-ivory">{t('home.ctaTitle')}</h2>
          <Link to="/contact" className="group mt-8 inline-flex items-center gap-3 px-10 py-4 bg-gold text-espresso text-xs tracking-[0.2em] uppercase hover:bg-gold-light transition-colors">
            {t('home.ctaButton')}<ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform rtl:rotate-180" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Products;
